import { sellerCustomerCareAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import translations from './useTaskLabel.translations'

export function useTaskLabels(task: sellerCustomerCareAPI.TaskType) {
  const i18n = useI18n()
  const logger = useLogger()

  switch (task) {
    case 'UPLOAD_RECEIPT':
      return i18n(translations.uploadReceiptTaskType)
    case 'SEND_MESSAGE':
      return i18n(translations.sendMessageTaskType)
    case 'REFUND':
      return i18n(translations.refundTaskType)
    case 'REPAIR_REPLACE':
      return i18n(translations.repairReplaceTaskType)
    case 'REPAIR':
      return i18n(translations.repairTaskType)
    case 'REPLACE':
      return i18n(translations.replaceTaskType)
    case 'RETURN_TO_CUSTOMER':
      return i18n(translations.returnToCustomerTaskType)
    case 'REPAIR_REPLACE_REFUND':
      return i18n(translations.repairReplaceRefundTaskType)

    default:
      logger.error(`Task type '${task}' is not supported.`, {
        owners: ['bot-squad-seller-care-front'],
      })

      return ''
  }
}
